import React from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import ArrowBack from "@material-ui/icons/ArrowBack";
import TimePicker from "material-ui-pickers/TimePicker";
import grey from "@material-ui/core/colors/grey";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";

import ItemSummary from "./components/ItemDetail/ItemSummary";
import AppBarTransparent from "../shared/components/AppBarTransparent";
import { connect } from "react-redux";
import { getInvitationById } from "../../redux/actions/sagaActions";
import TestItemDetailProjectRow from "./TestItemDetailProjectRow";
import CircularProgress from "@material-ui/core/CircularProgress";

const styles = theme => ({
  card: {
    maxWidth: 240
  },
  media: {
    // ⚠️ object-fit is not supported by IE11.
    objectFit: "cover"
  },
  container: {
    padding: 20
  },
  textRight: {
    textAlign: "right"
  },
  helpButton: {
    width: 32,
    height: 32
  },
  flexCenter: {
    display: "flex",
    alignItems: "center"
  },
  duracion: {
    justifyContent: "flex-end",
    color: grey["600"],
    fontWeight: 500
  },
  time: {
    justifyContent: "flex-end"
  },
  iconDate: {
    fontSize: 24,
    marginRight: 5
  }
});

function TabContainer({ children, dir }) {
  return (
    <Typography
      component="div"
      dir={dir}
      style={{ padding: 20, backgroundColor: grey["50"] }}
    >
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

class TestItemDetail extends React.PureComponent {
  el = null;

  state = {
    selectedStartDate: null,
    selectedEndDate: null,
    appBar: {
      background: "transparent"
    },
    activeTab: 0
  };

  componentDidMount() {
    this.el = document.getElementById("root");
    window.addEventListener("scroll", this.fireOnScroll, true);
    const {
      getInvitationById,
      match: {
        params: { id }
      }
    } = this.props;
    getInvitationById({ id });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.fireOnScroll, true);
  }

  fireOnScroll = e => {
    let offset = this.el.scrollTop;

    if (offset >= 10) {
      this.setState({
        appBar: {
          background:
            "rgba(237,74,71," + (offset <= 99 ? "0." + offset : 1) + ")"
        }
      });
    } else {
      this.setState({
        appBar: {
          background: "transparent"
        }
      });
    }
  };

  handleStartDateChange = date => {
    this.setState({ selectedStartDate: date });
  };

  handleEndDateChange = date => {
    this.setState({ selectedEndDate: date });
  };

  handleTabChange = (event, value) => {
    this.setState({
      activeTab: value
    });
  };

  handleSubmit = () => {
    console.debug(this.state);
    const { match } = this.props;
    const id = match.params.id;
    this.props.history.push(`/test/${id}/join`);
  };

  render() {
    const { classes, match, tests, common } = this.props;
    const { selectedStartDate, selectedEndDate } = this.state;
    const id = match.params.id;
    const item = tests[id] || null;
    const project = item ? item.project : null;

    return (
      <React.Fragment>
        {!item && <div style={{ marginTop: "64px" }}>
          <CircularProgress />
        </div>}
        {item && (
          <div style={{ overflowY: "auto" }} id="test-detail">
            <AppBarTransparent
              background={this.state.appBar.background}
              history={this.props.history}
            />

            <CardMedia
              component="img"
              className={classes.media}
              height="180"
              image="/assets/img/dummy/placeimg_320_320_arch.jpg"
              title="Contemplative Reptile"
            />

            <ItemSummary
              item={item}
              products={item.project ? item.project.products : []}
              showStudyNumber
              showHelpButton={false}
            />

            {/* <div>
          <ScrollableTabsButtonAuto />
        </div> */}

            {/*<div className={classes.container}>*/}
            {/*  <Grid container spacing={8}>*/}
            {/*    <Grid item xs={12}>*/}
            {/*      <TimePicker*/}
            {/*        ampm={false}*/}
            {/*        value={selectedStartDate}*/}
            {/*        onChange={this.handleStartDateChange}*/}
            {/*        emptyLabel="Selecciona la hora para tu cita (inicio)"*/}
            {/*        fullWidth*/}
            {/*        // InputProps={{*/}
            {/*        //   startAdornment: <InputAdornment position="end"><ArrowDropDown /></InputAdornment>,*/}
            {/*        // }}*/}
            {/*      />*/}
            {/*    </Grid>*/}
            {/*    <Grid item xs={12}>*/}
            {/*      <TimePicker*/}
            {/*        ampm={false}*/}
            {/*        value={selectedEndDate}*/}
            {/*        onChange={this.handleEndDateChange}*/}
            {/*        emptyLabel="Selecciona la hora para tu cita (fin)"*/}
            {/*        fullWidth*/}
            {/*        // InputProps={{*/}
            {/*        //   startAdornment: <InputAdornment position="end"><ArrowDropDown /></InputAdornment>,*/}
            {/*        // }}*/}
            {/*      />*/}
            {/*    </Grid>*/}
            {/*  </Grid>*/}
            {/*</div>*/}

            <div className={classes.container}>
              <Grid container spacing={8}>
                <Grid item xs={12}>
                  <Typography variant="headline" color="textPrimary">
                    <strong>Description del estudio</strong>
                  </Typography>
                </Grid>
              </Grid>
            </div>

            <div>
              <AppBar
                position="static"
                color="default"
                className={classes.appBar}
                elevation={0}
                style={{
                  backgroundColor: "#fff",
                  borderBottom: "1px solid #f5f5f5"
                }}
              >
                <Tabs
                  value={this.state.activeTab}
                  onChange={this.handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  fullWidth
                >
                  <Tab label="REQUISITOS" />
                  <Tab label="DETALLES" />
                  <Tab label="INDICACIONES" />
                </Tabs>
              </AppBar>
              {this.state.activeTab == 0 && (
                <TabContainer>
                  <Grid container spacing={8}>
                    <Grid item xs={12}>
                      <Typography
                        className={classes.flexCenter}
                        component="div"
                      >
                        <span style={{ color: grey["500"] }}>Sexo:</span> &nbsp;{" "}
                        <strong>{item.project.gender}</strong>
                      </Typography>
                    </Grid>
                    {/*<Grid item xs={12}>*/}
                    {/*  <Typography*/}
                    {/*    className={classes.flexCenter}*/}
                    {/*    component="div"*/}
                    {/*  >*/}
                    {/*    <span style={{ color: grey["500"] }}>*/}
                    {/*      Naturaleza piel del cuerpo:*/}
                    {/*    </span>{" "}*/}
                    {/*    &nbsp; <strong>China</strong>*/}
                    {/*  </Typography>*/}
                    {/*</Grid>*/}
                    <TestItemDetailProjectRow
                      field={"Edad:"}
                      value={`De ${project.age_start} a ${project.age_end} años`}
                    />

                    {/*<Grid item xs={12}>*/}
                    {/*  <Typography*/}
                    {/*    className={classes.flexCenter}*/}
                    {/*    component="div"*/}
                    {/*  >*/}
                    {/*    <span style={{ color: grey["500"] }}>Lentilas:</span>{" "}*/}
                    {/*    &nbsp; <strong>Sí</strong>*/}
                    {/*  </Typography>*/}
                    {/*</Grid>*/}
                  </Grid>
                </TabContainer>
              )}
              {this.state.activeTab == 1 && (
                <TabContainer>
                  <Grid container spacing={8}>
                    <TestItemDetailProjectRow
                      field={`Tipo de piel del cuerpo:`}
                      value={
                        <React.Fragment>
                          {!project.body_skin_type ||
                            (project.body_skin_type.length === 0 && (
                              <span>Indiferente</span>
                            ))}
                          {Array.isArray(project.body_skin_type) &&
                            project.body_skin_type.map(type => (
                              <span>
                                {
                                  common.body_skin_nature.find(
                                    i => i.id === type
                                  ).value
                                }
                                {" / "}
                              </span>
                            ))}
                        </React.Fragment>
                      }
                    />
                    <TestItemDetailProjectRow
                      field={"Tipo de piel del rostro:"}
                      value={
                        <React.Fragment>
                          {!project.face_skin_type ||
                            (project.face_skin_type.length === 0 && (
                              <span>Indiferente</span>
                            ))}
                          {Array.isArray(project.face_skin_type) &&
                            project.face_skin_type.map(type => (
                              <span>
                                {
                                  common.skin_nature.find(i => i.id === type)
                                    .value
                                }
                                {" / "}
                              </span>
                            ))}
                        </React.Fragment>
                      }
                    />
                    <TestItemDetailProjectRow
                      field={"Tipo de cabello:"}
                      value={
                        <React.Fragment>
                          {!project.hair_type ||
                            (project.hair_type.length === 0 && (
                              <span>Indiferente</span>
                            ))}
                          {Array.isArray(project.hair_type) &&
                            project.hair_type.map(type => (
                              <span>
                                {
                                  common.hair_type.find(i => i.id === type)
                                    .value
                                }
                                {" / "}
                              </span>
                            ))}
                        </React.Fragment>
                      }
                    />
                    <TestItemDetailProjectRow
                      field={"Tipo de cuero cabelludo:"}
                      value={
                        <React.Fragment>
                          {!project.head_skin_type ||
                            (project.head_skin_type.length === 0 && (
                              <span>Indiferente</span>
                            ))}
                          {Array.isArray(project.head_skin_type) &&
                            project.head_skin_type.map(type => (
                              <span>
                                {
                                  common.hair_and_scalp_nature.find(
                                    i => i.id === type
                                  ).value
                                }
                                {" / "}
                              </span>
                            ))}
                        </React.Fragment>
                      }
                    />
                    <TestItemDetailProjectRow
                      field={"Atopia:"}
                      value={
                        <React.Fragment>
                          {project.atopy_value}
                          <span>{"%"}</span>
                        </React.Fragment>
                      }
                    />
                    <TestItemDetailProjectRow
                      field={"Sensibilidad:"}
                      value={
                        <React.Fragment>
                          {project.sensitive_face_skin_value && (
                            <React.Fragment>
                              <span>Piel del rostro sensible</span>
                              <span>
                                {" "}
                                {project.sensitive_face_skin_type_value}{" "}
                              </span>
                              <span>
                                {" "}
                                {project.sensitive_face_skin_value}%{" "}
                              </span>
                            </React.Fragment>
                          )}
                          {" / "}
                          {project.sensitive_body_skin_value && (
                            <React.Fragment>
                              <span>Piel del cuerpo sensible</span>
                              <span>
                                {" "}
                                {project.sensitive_body_skin_type_value}{" "}
                              </span>
                              <span>
                                {" "}
                                {project.sensitive_body_skin_value}%{" "}
                              </span>
                            </React.Fragment>
                          )}
                        </React.Fragment>
                      }
                    />
                    <TestItemDetailProjectRow
                      field={"Ojos sensibles:"}
                      value={
                        <React.Fragment>
                          <span> {project.sensitive_eyes_type_value} </span>
                          <span> {project.sensitive_eyes_value}% </span>
                        </React.Fragment>
                      }
                    />
                    <TestItemDetailProjectRow
                      field={"Lentillas:"}
                      value={
                        <React.Fragment>
                          <span> {project.contact_lenses_type_value} </span>
                          <span> {project.contact_lenses_value}% </span>
                        </React.Fragment>
                      }
                    />
                  </Grid>
                </TabContainer>
              )}
              {this.state.activeTab == 2 && (
                <TabContainer>
                  <Grid container spacing={8}>
                    <Grid item xs={12}>
                      <Typography paragraph>
                        {project.additional_observations}
                      </Typography>
                      <Typography paragraph>
                        {project.refinements_method}
                      </Typography>
                    </Grid>
                  </Grid>
                </TabContainer>
              )}
            </div>

            <div className={classes.container}>
              <Grid container spacing={8}>
                <Grid item xs={12}>
                  <Typography variant="caption">
                    * Cosmocare se rezerva el derecho de no admitir a un
                    voluntario en el estudio si este no cumple loq requisitos
                    especificados.
                  </Typography>
                </Grid>
              </Grid>
            </div>
            <div className={classes.container}>
              <Grid container spacing={8}>
                <Grid item xs={6}>
                  {/*<Button>Preguntas ?</Button>*/}
                </Grid>
                <Grid item xs={6} style={{ textAlign: "right" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleSubmit}
                  >
                    Participar
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  tests: state.tests.invitations,
  common: state.common
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    { getInvitationById }
  )(TestItemDetail)
);



// WEBPACK FOOTER //
// ./src/modules/test/TestItemDetail.js